import { dialogTypes } from "@/constants/dialogTypes";

/**
 * Devuelve un dialogo en particular dependiendo del breadcrumb seleccionado
 * y teniendo en cuenta el ABM actual
 */
export const dialogUtil = {
    getDialog: (key, abmType) => {
        switch (abmType) {
            case DialogThing:
                return ThingABM[key]
            case DialogGPS:
                return GpsABM[key]
            case DialogLINE:
                return LineABM[key]
            case DialogEnterprise:
                return EnterpriseABM[key]
            case DialogGroup:
                return GroupABM[key]
            case DialogFleet:
                return FleetABM[key]
            case DialogCategory:
                return CategoryABM[key]
            case DialogAlertEvent:
                return AlertEventABM[key]
            case DialogWorkFront:
                return WorkFrontABM[key]
            case DialogFarm:
                return FarmABM[key]
            case DialogEcologicalUnit:
                return EcologicalUnitABM[key]
            case DialogUserProfile:
                return UserProfilesABM[key]
            case DialogUser:
                return UserABM[key]
            case DialogPerson:
                return PersonABM[key]
            case DialogMassiveUploadThing:
                return ThingMassiveUpload[key]
            case DialogDriveUnit:
                return DriveUnitABM[key]
            case DialogEventType:
                return EventTypeABM[key]
            case DialogStateType:
                return StateTypeABM[key]
            case DialogGoals:
                return GoalsABM[key]
            default:
                break
        }
    }
}

/**
 * Claves de los dialogs
 */
export const DialogThing = 'THING'
export const DialogGPS = 'MODULO'
export const DialogLINE = 'LINE'
export const DialogUserProfile = 'USER_PROFILES'
export const DialogEnterprise = 'ENTERPRISE'
export const DialogGroup = 'GROUP'
export const DialogFleet = 'FLEET'
export const DialogCategory = 'CATEGORY'
export const DialogAlertEvent = 'ALERT_EVENT'
export const DialogWorkFront = 'WORK_FRONT'
export const DialogFarm = 'FARM'
export const DialogEcologicalUnit = 'ECOLOGICAL_UNIT'
export const DialogUser = 'USER'
export const DialogPerson = 'PERSON'
export const DialogScoring = 'SCORING'
export const DialogMassiveUploadThing = 'THING_MASSIVE_UPLOAD'
export const DialogRuses = 'RUSES'
export const DialogEventConfiguration = 'EVENT_CONFIGURATION'
export const DialogEvent = 'EVENT'
export const DialogDriveUnit = 'DRIVE_UNIT'
export const DialogEventType = 'EVENT_TYPE'
export const DialogStateType = 'STATE_TYPE'
export const DialogSector = 'SECTOR'
export const DialogHarvest = 'FRANJA'
export const DialogGoals = 'GOALS'


/**
 * Dialogo del ABM Lineas
 */
const LineABM = {}
LineABM[DialogLINE] = {...dialogTypes.LINE}

/*
* Dialogo del ABM GPS
 */
const GpsABM = {}
GpsABM[DialogGPS] = {...dialogTypes.MODULO}
GpsABM[DialogLINE] = LineABM.LINE


/**
 * Dialogo del ABM Cosas
 */
const ThingABM = {}
ThingABM[DialogThing] = {...dialogTypes.THING}
ThingABM[DialogEvent] = {...dialogTypes.EVENT}
ThingABM[DialogEventType] = {...dialogTypes.EVENT_TYPE}
ThingABM[DialogStateType] = {...dialogTypes.STATE_TYPE}
ThingABM[DialogGPS] = {...dialogTypes.MODULO}
ThingABM[DialogGroup] = {...dialogTypes.GROUP}
ThingABM[DialogFleet] = {...dialogTypes.FLEET}
ThingABM[DialogWorkFront] = {...dialogTypes.WORK_FRONT}
ThingABM[DialogLINE] = {...dialogTypes.LINE}

/**
 * Dialogo del ABM Empresas
 */
const EnterpriseABM = {}
EnterpriseABM[DialogEnterprise] = {...dialogTypes.ENTERPRISE}
EnterpriseABM[DialogScoring] = {...dialogTypes.SCORING}
EnterpriseABM[DialogRuses] = {...dialogTypes.RUSES}
EnterpriseABM[DialogEventConfiguration] = {...dialogTypes.EVENT_CONFIGURATION}
EnterpriseABM[DialogEventType] = {...dialogTypes.EVENT_TYPE}
EnterpriseABM[DialogStateType] = {...dialogTypes.STATE_TYPE}
EnterpriseABM[DialogEvent] = {...dialogTypes.EVENT}
EnterpriseABM[DialogSector] = {...dialogTypes.SECTOR}
EnterpriseABM[DialogHarvest] = {...dialogTypes.HARVEST}


/**
 * Dialogo del ABM Grupos
 */
const GroupABM = {}
GroupABM[DialogGroup] = {...dialogTypes.GROUP}


/**
 * Dialogo del ABM Flotas
 */
const FleetABM = {}
FleetABM[DialogFleet] = {...dialogTypes.FLEET}

/**
 * Dialogo del ABM Categorías
 */
const CategoryABM = {}
CategoryABM[DialogCategory] = { ...dialogTypes.CATEGORY }

/**
 * Dialogo del ABM Alerta de Eventos
 */
const AlertEventABM = {}
AlertEventABM[DialogAlertEvent] = { ...dialogTypes.ALERT_EVENT }

/**
 * Dialogo del ABM Frentes de trabajo
 */
const WorkFrontABM = {}
WorkFrontABM[DialogWorkFront] = {...dialogTypes.WORK_FRONT}

/**
 * Dialogo del ABM Farms
 */
const FarmABM = {}
FarmABM[DialogFarm] = {...dialogTypes.FARM}

/**
 * Dialogo del ABM EcologicalUnit
 */
const EcologicalUnitABM = {}
EcologicalUnitABM[DialogEcologicalUnit] = {...dialogTypes.ECOLOGICAL_UNIT}
EcologicalUnitABM[DialogFarm] = FarmABM.FARM

/**
 * Dialogo del ABM de Perfiles de Usuario
 */
const UserProfilesABM = {}
UserProfilesABM[DialogUserProfile] = {...dialogTypes.USER_PROFILES}

/**
 * Dialogo del ABM de Usuarios
 */
const UserABM = {}
UserABM[DialogUser] = {...dialogTypes.USER}
UserABM[DialogUserProfile] = {...dialogTypes.USER_PROFILES}

/**
 * Dialogo del ABM de Personas
 */
const PersonABM = {}
PersonABM[DialogPerson] = {...dialogTypes.PERSON}

/**
 * Dialogo del ABM de Equipos para carga masiva
 */
const ThingMassiveUpload = {}
ThingMassiveUpload[DialogMassiveUploadThing] = {...dialogTypes.THING_MASSIVE_UPLOAD}

/**
 * Dialogo del ABM de unidades de manejo
 */
const DriveUnitABM = {}
DriveUnitABM[DialogDriveUnit] = {...dialogTypes.DRIVE_UNIT}
DriveUnitABM[DialogFarm] = {...dialogTypes.FARM}
DriveUnitABM[DialogEcologicalUnit] = {...dialogTypes.ECOLOGICAL_UNIT}

/**
 * Dialogo del ABM de tipos de eventos
 */
const EventTypeABM = {}
EventTypeABM[DialogEventType] = {...dialogTypes.EVENT_TYPE}

/**
 * Dialogo del ABM de tipos de estados
 */
const StateTypeABM = {}
StateTypeABM[DialogStateType] = {...dialogTypes.STATE_TYPE}

/**
 * Dialogo del ABM de metas
 */

const GoalsABM = {}
GoalsABM[DialogGoals] = {...dialogTypes.GOALS}


